const en = {
  // Hero Section
  hero: {
    title: "Your Intelligent",
    titleHighlight: "Medical",
    subtitle: "Companion",
    description:
      "Streamline patient management, appointments, and medical records with RAQIB's comprehensive healthcare dashboard.",
    buttonGetStarted: "Get Started",
    buttonWatchDemo: "Watch Demo",
  },

  // Features Section
  features: {
    sectionTitle: "Comprehensive Healthcare Management",
    sectionDescription:
      "RAQIB provides all the tools you need to efficiently manage your medical practice and deliver exceptional patient care.",
    items: [
      {
        emoji: "👨‍⚕️",
        title: "Patient Management",
        description:
          "Complete patient profiles with medical history, allergies, medications, and treatment plans all in one place.",
      },
      {
        emoji: "📅",
        title: "Smart Scheduling",
        description:
          "Intuitive appointment system with automated reminders to reduce no-shows and optimize your schedule.",
      },
      {
        emoji: "💊",
        title: "Prescription Management",
        description:
          "Create, track, and manage prescriptions digitally with integration to pharmacies.",
      },
      {
        emoji: "📊",
        title: "Medical Analytics",
        description:
          "Powerful analytics to track patient outcomes, clinic performance, and financial metrics.",
      },
      {
        emoji: "💳",
        title: "Billing & Insurance",
        description:
          "Streamlined billing process with insurance claim support and payment tracking.",
      },
      {
        emoji: "🛡️",
        title: "HIPAA Compliant",
        description:
          "Enterprise-grade security and compliance to protect sensitive patient health information.",
      },
    ],
  },

  // Demo Video Section
  demoVideo: {
    title: "See RAQIB in Action",
    description:
      "Watch our 2-minute demo to see how RAQIB can transform your medical practice management.",
    benefits: [
      "Reduce administrative workload by 60%",
      "Improve patient satisfaction with seamless experience",
      "Access critical patient data anytime, anywhere",
    ],
    videoDemoTitle: "RAQIB Platform Demo",
  },

  // Testimonials Section
  testimonials: {
    sectionTitle: "Trusted by Healthcare Professionals",
    items: [
      {
        initials: "DR",
        name: "Dr. Sarah Johnson",
        title: "Cardiologist, City Hospital",
        text: "RAQIB has transformed how we manage patient care. The intuitive interface saves us hours each week, allowing us to focus on what matters most - our patients.",
        rating: 5,
      },
      {
        initials: "NP",
        name: "Nurse Priya Patel",
        title: "Nurse Practitioner",
        text: "The medication tracking and prescription features are game-changers. I can now manage all my patients' medications without worrying about errors.",
        rating: 5,
      },
      {
        initials: "AM",
        name: "Alex Morgan",
        title: "Clinic Administrator",
        text: "Our billing process used to take days. With RAQIB, we complete it in hours. The reporting features help us make data-driven decisions for our practice.",
        rating: 4,
      },
    ],
  },



  // Pricing Section
  pricing: {
    sectionTitle: "Simple, Transparent Pricing",
    description:
      "Choose the plan that fits your practice's needs. No hidden fees, cancel anytime.",
  },

  // CTA Section
  cta: {
    title: "Ready to Transform Your Healthcare Practice?",
    description:
      "Join thousands of healthcare professionals who trust RAQIB for their practice management needs.",
    buttonStartTrial: "Start Free Trial",
    buttonScheduleDemo: "Schedule Demo",
  },
};

export default en;
